import { Box, Typography, Chip, Button, Alert, Dialog } from "@mui/material";
import CircledBackButton from "@/features/Common/components/CircledBackButton";
import type {
  HealthPermissions,
  HealthRecord,
} from "@/hooks/useNativeHealthSDK";

interface LifestyleDashboardProps {
  isOpen: boolean;
  onBack: () => void;
  isConnected: boolean;
  hasAnyPermissions: boolean;
  isAvailable: boolean;
  permissions: HealthPermissions | null;
  records: HealthRecord[];
  onFetchData: () => void;
}

export default function LifestyleDashboard({
  isOpen,
  onBack,
  isConnected,
  hasAnyPermissions,
  isAvailable,
  permissions,
  records,
  onFetchData,
}: LifestyleDashboardProps) {
  return (
    <Dialog
      fullScreen
      open={isOpen}
      onClose={onBack}
      PaperProps={{
        sx: {
          bgcolor: "background.paper",
        },
      }}
    >
      <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
        <CircledBackButton showLabel={true} onClick={onBack} />
        <Typography variant="body1">
          Platform Health Service available:{" "}
          <Chip
            label={isAvailable ? "Yes" : "No"}
            color={isAvailable ? "success" : "error"}
            size="small"
          />
        </Typography>
        <Typography variant="body1">
          Connected to Health Connect:{" "}
          <Chip
            label={isConnected || hasAnyPermissions ? "Yes" : "No"}
            color={isConnected || hasAnyPermissions ? "success" : "error"}
            size="small"
          />
        </Typography>
        <Box gap={2}>
          <Typography variant="body1">Permissions:</Typography>
          {permissions?.dataTypes.map((permission) => (
            <Typography
              variant="body1"
              key={permission.type}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                justifyContent: "space-between",
              }}
            >
              {permission.type}
              <Chip
                label={
                  permission.read === "authorized" ? "Authorized" : "Denied"
                }
                color={permission.read === "authorized" ? "success" : "error"}
                size="small"
              />
            </Typography>
          ))}
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Button
            variant="contained"
            onClick={onFetchData}
            disabled={!isConnected && !hasAnyPermissions}
          >
            Fetch Data
          </Button>
          {records.length > 0 ? (
            <Alert severity="info">Fetched {records.length} records</Alert>
          ) : (
            <Alert severity="info">[No records found]</Alert>
          )}
        </Box>
      </Box>
    </Dialog>
  );
}
